import { render } from "./PageLogos.vue?vue&type=template&id=44d42d66"
import script from "./PageLogos.vue?vue&type=script&lang=js"
export * from "./PageLogos.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__